'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hashCode = exports.filterRealChildren = exports.EMPTY_TEXT = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.checkIsRequired = checkIsRequired;
exports.wrapperFieldProtoView = wrapperFieldProtoView;
exports.calculateBehavior = calculateBehavior;
exports.calculateLayout = calculateLayout;
exports.calculateFieldData = calculateFieldData;
exports.calculateOptions = calculateOptions;
exports.calculateLabelAlign = calculateLabelAlign;
exports.convertOptionsText = convertOptionsText;
exports.convertOptionsCascade = convertOptionsCascade;
exports.uuidFileName = uuidFileName;
exports.getDefaultOptions = getDefaultOptions;
exports.getLocateProp = getLocateProp;
exports.completeOptions = completeOptions;
exports.isIE = isIE;
exports.defaultValueRender = defaultValueRender;
exports.uuid = uuid;
exports.walkTree = walkTree;
exports.getQuery = getQuery;

var _lodash = require('lodash');

var _queryString = require('query-string');

var _queryString2 = _interopRequireDefault(_queryString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

function checkIsRequired(rules) {
  var required = false;
  if (rules && Array.isArray(rules)) {
    required = rules.some(function (rule) {
      return rule.type === 'required';
    });
  }

  return required;
}

// 解决默认值在设计视图中实时更新的问题
function wrapperFieldProtoView(Parent) {
  return function (_Parent) {
    _inherits(ProtoView, _Parent);

    function ProtoView() {
      _classCallCheck(this, ProtoView);

      return _possibleConstructorReturn(this, _Parent.apply(this, arguments));
    }

    ProtoView.prototype.getSnapshotBeforeUpdate = function getSnapshotBeforeUpdate(prevProps) {
      if (!(0, _lodash.isEqual)(this.props.value, prevProps.value)) {
        return {
          type: 'value',
          data: this.props.value
        };
      }
      if (this.props.behavior !== prevProps.behavior) {
        return {
          type: 'behavior',
          data: this.props.behavior
        };
      }

      return null;
    };

    ProtoView.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState, snapshot) {
      if (snapshot !== undefined && snapshot !== null) {
        if (snapshot.type === 'value') {
          this.setValue(snapshot.data, true);
        } else if (snapshot.type === 'behavior') {
          this.setBehavior(snapshot.data);
        }
      }
    };

    // 因为在设计器里面有一层 wrapper 导致 Form 容器传过来的自定义 Props 丢失
    // field 实例为空，设计器里面的值只能从 props 里面去拿，不能从 field 去拿


    ProtoView.prototype.getValue = function getValue() {
      return this.props.value;
    };

    return ProtoView;
  }(Parent);
}

// behavior 从 readonly和visible中计算得来
function calculateBehavior(props) {
  var behavior = props.behavior,
      readonly = props.readonly,
      visible = props.visible,
      disabled = props.disabled;

  var fieldBehavior = 'NORMAL';
  if (window.VisualEngine) {
    // VE 中将默认状态为 HIDDEN 的组件展示出来
    fieldBehavior = (props.defaultBehavior || {}).fieldBehavior || 'NORMAL';
  } else {
    fieldBehavior = behavior && behavior.fieldBehavior ? behavior.fieldBehavior : 'NORMAL';
  }
  if (readonly) {
    fieldBehavior = 'READONLY';
  }
  if (disabled) {
    fieldBehavior = 'DISABLED';
  }
  if (visible === false) {
    fieldBehavior = 'HIDDEN';
  }
  return fieldBehavior;
}

function calculateLayout(props) {
  var labelAlign = props.labelAlign,
      showLabel = props.showLabel,
      style = props.style;

  if (!showLabel || labelAlign === 'inset') {
    return {
      labelCol: { span: 0, offset: 0 },
      wrapperCol: { span: 23, offset: 1 }
    };
  }
  return {
    labelCol: { span: 2, offset: 0 },
    wrapperCol: { span: 22, offset: 0 }
  };
}

function calculateFieldData(props) {
  if (props.value) {
    return { value: props.value };
  }
  if (props.fieldData) {
    return props.fieldData;
  }
  return {};
}

function calculateOptions(props) {
  var realOptions = [];
  var dataSource = props.dataSource,
      options = props.options;

  if (Array.isArray(options) && !(0, _lodash.isEmpty)(options)) {
    realOptions = options;
  } else if (dataSource && (typeof dataSource === 'undefined' ? 'undefined' : _typeof(dataSource)) === 'object' && 'options' in dataSource) {
    realOptions = dataSource.options;
  }
  // 滤除无效的 options
  realOptions = realOptions.filter(function (item) {
    return !(0, _lodash.isNil)(item.value);
  });
  return realOptions;
}

function calculateLabelAlign(props) {
  var layout = props.layout,
      labelAlign = props.labelAlign;

  if (labelAlign) {
    return labelAlign;
  }
  if (layout === 'HORIZONTAL') {
    return 'left';
  } else if (layout === 'VERTICAL') {
    return 'top';
  } else {
    return 'left'; // DEFAULT
  }
}

function convertOptionsText(options) {
  if ((0, _lodash.isNil)(options) || !Array.isArray(options) || (0, _lodash.isEmpty)(options)) {
    return [];
  }
  return options.filter(function (item) {
    return !!item;
  }).map(function (item) {
    var newItem = {
      label: item.text || item.label || item.value,
      value: item.value
    };
    if (!(0, _lodash.isNil)(item.isLeaf)) {
      newItem.isLeaf = item.isLeaf;
    }
    if (!(0, _lodash.isEmpty)(item.children)) {
      newItem.children = convertOptionsText(item.children);
    }
    return newItem;
  });
}

function convertOptionsCascade(options, cascade) {
  if ((0, _lodash.isEmpty)(options)) return options;
  options.forEach(function (item) {
    if (cascade > 1) {
      item.children = convertOptionsCascade(item.children, cascade - 1);
    } else {
      delete item.children;
    }
  });

  return options;
}

function uuidFileName(fileName) {
  var timestamp = Date.now();
  var uid = uuid();
  var group = fileName && fileName.match(/(.*)(\.\w+)$/);
  if (group && group[2]) {
    return uid + '_' + timestamp + group[2];
  }
  return '' + timestamp + fileName;
}

function getDefaultOptions(options) {
  var defaultItems = [];
  (options || []).forEach(function (option) {
    if (option.defaultChecked) {
      defaultItems.push({
        text: option.text || option.label,
        value: option.value
      });
    }
  });
  return defaultItems;
}

function getLocateProp(propValue) {
  var locate = window.VisualEngine.Env.getLocale() || 'zh_CN';
  if (propValue && propValue.type === 'i18n') {
    return propValue[locate];
  }
  return propValue;
}

// 空内容时的占位符
var EMPTY_TEXT = exports.EMPTY_TEXT = '--';

var CONTAINER_COMPS = ['AutoColumnsLayout', 'ColumnsLayout', 'GroupLayout', 'Column'];

var filterRealChildren = exports.filterRealChildren = function filterRealChildren(children) {
  if ((0, _lodash.isEmpty)(children)) {
    return [];
  }
  var realChildren = [];
  children.forEach(function (child) {
    if (CONTAINER_COMPS.includes(child.componentName)) {
      realChildren.push.apply(realChildren, _toConsumableArray(filterRealChildren(child.children)));
    } else {
      realChildren.push(child);
    }
  });
  return realChildren;
};

var hashCode = exports.hashCode = function hashCode(str) {
  var hash = 0;
  for (var i = 0; i < str.length; i++) {
    var character = str.charCodeAt(i);
    hash = (hash << 5) - hash + character;
    hash = hash & hash; // Convert to 32bit integer
  }
  return hash;
};

function completeOptions(value) {
  if (Array.isArray(value)) {
    return (0, _lodash.cloneDeep)(value);
  } else if ((0, _lodash.isObject)(value)) {
    return [(0, _lodash.cloneDeep)(value)];
  }
}

function isIE() {
  if (!!window.ActiveXObject || 'ActiveXObject' in window) {
    return true;
  } else {
    return false;
  }
}

function defaultValueRender(item) {
  if (item) {
    return item.text || item.label || item.value;
  }
  return '';
}

function uuid() {
  var len = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8;

  var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
  var result = [];
  var radix = chars.length;
  var i = void 0;
  // Compact form
  for (i = 0; i < len; i++) {
    // eslint-disable-next-line no-bitwise
    result[i] = chars[0 | Math.random() * radix];
  }
  return result.join('');
}

function walkTree(options, cache) {
  if (!cache) cache = {};

  if (options === null || options === undefined || !options.map) {
    return cache;
  }

  options.filter(function (item) {
    return !!item;
  }).forEach(function (item) {
    cache[item.value] = {
      label: item.text || item.label || item.value,
      value: item.value
    };
    if (!(0, _lodash.isEmpty)(item.children)) {
      walkTree(item.children, cache);
    }
  });

  return cache;
}

function getQuery() {
  var match = window.location.href.match(/\?(.*)$/);
  var search = match ? match[1] : '';
  var query = _queryString2.default.parse(search, {
    parseBooleans: true
  });
  return query;
}